module.exports = __webpack_public_path__ + "static/media/traliccio.60d7652b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/traliccio.png
// module id = 480
// module chunks = 0